<template>
  <div
    id="integrationSetting"
    class="mx-5"
  >
    <div class="mt-2 d-flex justify-space-between">
      <div class="d-flex">
        <v-img
          :max-width="100"
          contain
          :src="require(`@/assets/conectiontab/maropost.png`)"
          class="mx-3 mt-1"
        />
        <h2
          style="line-height:85px;"
          class="mr-3"
        >
          Abandoned Cart REST API
        </h2>
      </div>
      <v-col cols="1">
        <v-btn
          v-track="'close-abandoned-cart-drawer'"
          class="text-right mt-3"
          icon
          @click.stop="
            $store.commit('ui/drawer.right.toggle')
          "
        >
          <v-icon
            style="background-color:transparent"
            medium
          >
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </div>
    <div class="mx-3">
      <h2>  Edit Integration Settings</h2>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-text-field
          v-model="payload.shop_name"
          label="Shop Name *"
          outlined
          class="pt-3"
          :rules="validateNameField"
        /> 
        <v-text-field
          v-model="payload.shop_url"
          label="Shop URL *"
          outlined
          disabled
          class="pt-3"
        />
        <v-card
          class="px-4 mt-3 py-2 mb-8">
          <div class="abandoned-trigger-time-div">
            <div class="my-2 d-flex">
              <h4 class="mr-1">
                Abandoned Cart Delay
              </h4>
              <v-tooltip
                top
                color="rgba(0, 0, 0, 0.9)"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-track="'mcc-shop-url-info'"
                    icon
                    small
                    v-on="on"
                  >
                    <v-icon size="20">
                      mdi-information-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>
                  This is the time after which the user will get first email once their cart is considered abandoned.
                </span>
              </v-tooltip>
            </div>
            <v-row>
              <v-col class="pb-0">
                <v-divider class="pb-4" />
                <v-autocomplete
                  v-track="'abandoned-cart-delay-hours'"
                  :items="[0,1,2,3,4,5,6]"
                  v-model="payload.abandoned_cart_delay.hours"
                  label="Hours"
                  outlined
                  required
                  :item-color="constants.status.recurring.color"
                  class="custom-selectbox mr-2"
                  dense
                  light
                  :menu-props="{maxHeight:150}"
                  @change="checkAndSetHrsAttr"
                />
              </v-col>
              <v-col class="pb-0">
                <v-divider class="pb-4" />
                <v-autocomplete
                  v-track="'abandoned-cart-delay-mins'"
                  v-model="payload.abandoned_cart_delay.minutes"
                  :items="[0,15,30,45]"
                  item-text="name"
                  item-value="name"
                  label="Minutes"
                  outlined
                  required
                  :item-color="constants.status.recurring.color"
                  class="custom-selectbox mr-2"
                  dense
                  light
                  :disabled="payload.abandoned_cart_delay.hours == 6"
                  :menu-props="{maxHeight:150}"
                />
              </v-col>
            </v-row>
            <v-divider class="mt-0 pb-2" />
          </div>
        </v-card>
        <v-btn
          v-track="'update-abandoned-cart-btn'"
          :loading="loading"
          dark
          :dark="valid"
          :disabled="!valid"
          @click="updateStore()"
        >
          Save
        </v-btn>
      </v-form>
    </div>
  </div>
</template>
<script>
import { $integrations } from '@/services'
import commonFunctions from "@/commonFunctions";
import constants from '@/constants'
import { getSplitKey } from '@/splitClient';
export default{
  name: 'AbandonedCartApiDrawer',
  components: {
    UniqueField : () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ?  import( '@/components/shared/UIDUniqueField.vue') : import( '@/components/shared/UniqueField.vue') 
  },
  data () {
    return {
      payload:{
        abandoned_cart_delay: {
          hours: 0,
          minutes: 30
        }
      },
      valid: true,
      loading: false,
      storeId: null,
      constants: constants,
      list:[],
      validateNameField: [
        commonFunctions.required('Name'),
        commonFunctions.maxLength(150, 'Name'),
        commonFunctions.checkForEmoji(),
        (v) => this.uniqueName(v)
      ]
    }
  },
  mounted(){
    this.storeId = this.$store.getters['ui/drawer'].right.storeId.id;
    this.list = this.$store.getters['ui/drawer'].right.list || [];
    this.getStoreById();
  },
  methods: {
    uniqueName(v) {
      const isNameExist = this.list.find(
        item => item.nick_name.toLowerCase() === v.toLowerCase()
          && item.id !== this.payload.shop_id
          && item.active
      )
      return !isNameExist || "Name has already been taken"
    },
    getStoreById(){
      this.loading = true;
      $integrations.getShopById(this.storeId).then(response => {
        this.payload = response.data.data;
      })
      .finally(()=>{
        this.loading = false;
      })
    },
    validate () {
      return this.$refs.form.validate()
    },
    updateStore(){
      this.valid = this.validate();
      if (this.valid) {
        this.loading = true;
        let payload = {
          shop : {
            shop_name: this.payload.shop_name,
            abandoned_cart_delay: this.payload.abandoned_cart_delay
          }
        }
        $integrations.toggleShop(this.storeId,payload).then(response =>{
          this.$store.commit('ui/drawer.right.toggle');
          this.$store.commit('ui/snackbar', {
            message: response.data.message,
            type: 'success',
          })
          this.$root.$emit('getStoresListTrigger')
        })
        .finally(()=>{
          this.loading = false;
        })
      }
    },
    checkAndSetHrsAttr(){
      if(this.payload.abandoned_cart_delay.hours == 6){
        this.payload.abandoned_cart_delay.minutes = 0
      }
    }
  }
}
</script>